module.exports = __webpack_public_path__ + "static/media/Paris Cam-2-mobile.f814e055.webp";